// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__fFDw6"};